import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {UserRestService} from "@core/modules/rest/user/user-rest.service";
import {Observable} from "rxjs";
import {TermsAndConditionsResponseModel} from "@core/modules/rest/user/response/terms-and-conditions-response.model";
import {map} from "rxjs/operators";
import {DATA_PROCESSING} from "@core/services/routes.service";

@Injectable({
    providedIn: 'root',
})
export class DataProcessingGuard implements CanActivate {

    constructor(protected readonly userService: UserRestService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
        return this.userService.checkTermsAndConditions().pipe(map((data: TermsAndConditionsResponseModel) => {
            if (data !== null && data) {
                return true;
            } else {
                return this.router.createUrlTree([DATA_PROCESSING]);
            }
        }));
    }

}
